/**
 * [INPUT]: 依赖 React Context、系统深色偏好与 localStorage
 * [OUTPUT]: 对外提供 ThemeProvider、useTheme 与三种 Theme 值
 * [POS]: app 的主题状态边界，只写 html[data-theme] 并让样式消费语义 Token
 * [PROTOCOL]: 变更时更新此头部，然后检查 AGENTS.md
 */

import { useEffect, useMemo, useState, type ReactNode } from 'react'

import { ThemeContext, type Theme } from './theme'
const STORAGE_KEY = 'morrow-theme'
function initialTheme(): Theme {
  const saved = localStorage.getItem(STORAGE_KEY)
  if (saved === 'paper-white' || saved === 'paper-warm' || saved === 'night-ink') return saved
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'night-ink' : 'paper-white'
}

export function ThemeProvider({ children }: { children: ReactNode }) {
  const [theme, setTheme] = useState<Theme>(initialTheme)
  useEffect(() => {
    document.documentElement.dataset.theme = theme
    localStorage.setItem(STORAGE_KEY, theme)
    document
      .querySelector('meta[name="theme-color"]')
      ?.setAttribute(
        'content',
        theme === 'night-ink' ? '#121619' : theme === 'paper-warm' ? '#f3efe8' : '#f4f5f5',
      )
  }, [theme])
  const value = useMemo(() => ({ theme, setTheme }), [theme])
  return <ThemeContext.Provider value={value}>{children}</ThemeContext.Provider>
}
